import { Check, X } from "lucide-react";
import LeftIconButton from "../UI/buttonUI/LeftIconButton";

const MultipleCheck = ({
  isMultipleCheck,
  setMultipleCheck,
  enableMultiCheckApplyBtn,
  cancelMultipleCheck,
  handleMultiCheckConfirmDialog,
  checkedData,
}) => {
  const handleMultipleCheck = () => {
    setMultipleCheck(true);
  };
  const checkDataObj = { ids: [], statuses: [] };
  checkedData.forEach((item) => {
    checkDataObj.ids.push(item.id);
    checkDataObj.statuses.push(item.status);
  });
  return (
    <>
      {isMultipleCheck ? (
        <div className="flex gap-1">
          <LeftIconButton
            text="Apply"
            btnStyle={`hover:bg-[#021472e3] mr-1 text-white max-lg:text-xs  ${
              enableMultiCheckApplyBtn
                ? "bg-dark-blue"
                : "cursor-not-allowed pointer-events-none bg-blue-disable"
            } ${
              enableMultiCheckApplyBtn
                ? ""
                : "cursor-not-allowed pointer-events-none"
            }`}
            Icon={Check}
            size={18}
            onClick={() =>
              handleMultiCheckConfirmDialog(
                checkDataObj.ids,
                checkDataObj.statuses
              )
            }
          />

          <LeftIconButton
            text="Cancel"
            btnStyle="text-dark-blue bg-lg5 hover:bg-gray-200 max-lg:text-xs"
            Icon={X}
            size={18}
            onClick={cancelMultipleCheck}
          />
        </div>
      ) : (
        <LeftIconButton
          text="Select Multiple"
          btnStyle="text-white bg-dark-blue hover:bg-[#021472e3] mr-1 max-lg:text-xs"
          Icon={Check}
          size={18}
          onClick={handleMultipleCheck}
        />
      )}
    </>
  );
};
export default MultipleCheck;
